'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'message-lines';
var width = 512;
var height = 512;
var aliases = ["comment-alt-lines"];
var unicode = 'f4a6';
var svgPathData = 'M0 32l0 416 128 0 0 96 160-96 224 0 0-416-512 0zM152 176l232 0 0 48-256 0 0-48 24 0zm0 96l136 0 0 48-160 0 0-48 24 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMessageLines = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;